import { V4 } from '@moleculeone/utils';
import cx from 'classnames';

import { txt, wedgePoints, wedgeTxt } from './bond-utils';

export function BondWedge(props: any) {
  const { pos1, pos2, bgColor, bgOpacity, color, className } = props;
  const wedge = wedgePoints(pos1, pos2, 2, 18);
  const points = wedgeTxt(wedge);
  return (
    <>
      <polygon
        points={points}
        strokeWidth="18px"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke={bgColor}
        opacity={bgOpacity}
        className={cx('bond', className)}
      />
      <polygon
        points={points}
        strokeWidth="4.5px"
        strokeLinejoin="round"
        strokeLinecap="round"
        fill={color}
        className={className}
      />
    </>
  );
}

export function BondDashed(props: any) {
  const { pos1, pos2, bgColor, bgOpacity, color, className } = props;
  const wedge = wedgePoints(pos1, pos2, 2, 18);
  const points = wedgeTxt(wedge);
  const { startLeft, startRight, endLeft, endRight } = wedge;

  const path: any = [];
  for (let i = 0; i <= 9; i++) {
    const frac = i / (9 + 0.1);
    const dl = V4.affine(startLeft, frac, endLeft);
    const dr = V4.affine(startRight, frac, endRight);
    path.push(`M${txt(dl)} L ${txt(dr)}`);
  }

  return (
    <>
      <polygon
        points={points}
        strokeWidth="18px"
        strokeLinejoin="round"
        strokeLinecap="round"
        stroke={bgColor}
        opacity={bgOpacity}
        className={cx('bond', className)}
      />
      <path
        d={path.join(' ')}
        strokeWidth="4px"
        strokeLinejoin="round"
        strokeLinecap="butt"
        stroke={color}
        className={className}
      />
    </>
  );
}

// Dashed.propTypes = bondLineShape;
